import React from 'react';
import { useOutletContext } from 'react-router-dom';
import DocumentRepository from './DocumentRepository';

function DocumentRepositoryWrapper() {
  const context = useOutletContext();

  return (
    <DocumentRepository
      user={context.user}
      hasActiveSubscription={context.hasActiveSubscription}
      subscriptionTier={context.subscriptionTier}
    />
  );
}

export default DocumentRepositoryWrapper;
